import gql from "graphql-tag";

const UPDATE_PRICES_FROM_PRICELIST = gql`
  mutation updatePricesFromPriceList($userId: ID!, $priceListId: ID!) {
    updatePricesFromPriceList(userId: $userId, priceListId: $priceListId)
  }
`;

export default UPDATE_PRICES_FROM_PRICELIST;
